import { padStart } from 'lodash';

function formatDate(dateInstance: any, format: string) {
  const year = dateInstance.getFullYear();
  const month = padStart(dateInstance.getMonth() + 1, 2, '0');
  const date = padStart(dateInstance.getDate(), 2, '0');
  const hours = padStart(dateInstance.getHours(), 2, '0');
  const minutes = padStart(dateInstance.getMinutes(), 2, '0');

  if (format) {
    return year + format + month + format + date + ' ' + hours + ':' + minutes;
  } else {
    return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes;
  }
}

export { formatDate };
